import React, { Component } from 'react';
import { Label } from 'reactstrap';
import { List, Divider } from '@material-ui/core';
import ItemListReceivedRequest from './ItemListReceivedRequest.js';
import {FormattedMessage} from 'react-intl';

class RequestsReceived extends Component{

  createReceivedRequestsList(){
    if((this.props.requests_List !== undefined)&&(this.props.requests_List.length > 0)) {
      return(
        <List style={{ width: "100%", padding: "0", height: "content" }}>
          {this.props.requests_List.map((request) => {
            return(
              <ItemListReceivedRequest request={request} profilesInformation={this.props.profilesInformation} accountMailAddress={this.props.accountMailAddress} reloadUserAndProfiles= {this.props.reloadUserAndProfiles}/>
            )
          })}
        </List>
      );
    } 
    else {
      return (
        <center>
          <Divider style={{ width: "auto", backgroundColor:"#000000", marginBottom: "5px" }}/>
          <Label style={{ textAlign: "center", fontWeight: "bold" }}>
            <FormattedMessage id="invitation.noReq" defaultMessage="No request"/>
          </Label>
        </center>
      );
    }
  }
  
  render(){
    return (
      <div>
        {this.createReceivedRequestsList()}
      </div>
      );  
    }
  }
export default RequestsReceived;